import { render, staticRenderFns } from "./addNewActivites.vue?vue&type=template&id=f3bd3f1a&scoped=true"
import script from "./addNewActivites.vue?vue&type=script&lang=js"
export * from "./addNewActivites.vue?vue&type=script&lang=js"
import style0 from "./addNewActivites.vue?vue&type=style&index=0&id=f3bd3f1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bd3f1a",
  null
  
)

export default component.exports